
import Vue from 'vue';

import { QueryResult } from '@root/modules/headlines/types/headlines';
import { Data as Tag } from '@root/modules/tags/types/tag';
import LinkHandler from '@core/components/helpers/LinkHandler.vue';

const Pagination = () => import(/* webpackChunkName: "TagsList/Pagination" */ '@root/common/components/base/pagination/Pagination.vue');

interface Props {
  list: QueryResult;
  pagination?: boolean;
}

interface Methods {
  tagUrl: (tag: Tag) => string;
}

export default Vue.extend<unknown, Methods, unknown, Props>({
  components: {
    LinkHandler,
    Pagination,
  },
  props: {
    list: {
      type: Object,
      required: true,
    },
    pagination: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  methods: {
    tagUrl(tag) {
      const { locale } = this.$channelConfig('settings');
      const fakeDomainEnabled = this.$config.FAKE_DOMAIN_ENABLED;
      return this.$options.filters!.tagUrl({ tag, locale, fakeDomainEnabled });
    },
  },
});
